import { AppStateLogin } from ".";
import { navigatorToUs } from "../../utils/Languages";
import { StorageHelper } from "../../utils/StorageHelper";
import { ProfileState } from "../userProfile";
import {
  ISetDataFromAuth,
  IUserProfileSuccessAction,
  USER_PROFILE,
} from "../userProfile/types";
import { RoleType } from "../users";
import {
  AUTHENTICATION,
  AuthActionTypes,
  IAddEmail,
  IAddEmailEndFailure,
  IAddPhone,
  IAddPhoneFailure,
  IBaseURLRetrieved,
  IChangePasswordFailure,
  IChangeRegisterLanguage,
  IEditUsername,
  IEditUsernameClean,
  IEditUsernameEnd,
  IEditUsernameEndFailure,
  IEditUsernameEndSuccess,
  IEditUsernameFailure,
  IEditUsernameSuccess,
  IGetForgotPasswordEmail,
  IGetForgotPasswordEmailSuccess,
  ILogoutNew,
  ISetIsAuthenticated,
  ISetIsError,
  ISignInCheckResult,
  ISingInPasswordlessFinishSuccess,
  IValidateToken,
} from "./types";

const initialState: AppStateLogin = {
  isAuthorized: !!StorageHelper.instance.GetAccessToken(),
  isAuthenticated: false,
  isLoading: false,
  error: undefined,
  isLoggedOut: false,
  isBaseUrlRetrieved: false,
  redirectTo: "",
  dateWhenExpire: StorageHelper.instance.GetExpireDate(),
  changePassResult: undefined,
  resetPassword: undefined,
  signUp: { language: navigatorToUs() },
  signIn: undefined,
  isPasswordLess: undefined,
  addPhone: undefined,
  addEmail: undefined,
  changeEmail: undefined,
  changePhone: undefined,
};

const reducer = (
  state = initialState,
  action: AuthActionTypes
): AppStateLogin => {
  switch (action.type) {
    case AUTHENTICATION.LOGOUT_NEW_SUCCESS: {
      return {
        ...state,
        isAuthorized: false,
        isAuthenticated: false,
        isLoading: false,
        isLoggedOut: true,
        redirectTo: (action as ILogoutNew).payload.redirectTo,
        dateWhenExpire: undefined,
      };
    }

    case USER_PROFILE.SUCCESS_FOR_CHECK_TOKEN: {
      return {
        ...state,
        isAuthorized: true,
        isAuthenticated: true,
        isLoading: false,
      };
    }
    case AUTHENTICATION.LOGOUT_NEW_FAILURE: {
      return {
        ...state,
        isAuthorized: false,
        isAuthenticated: false,
        isLoading: false,
        dateWhenExpire: undefined,
      };
    }
    case AUTHENTICATION.SET_IS_AUTHENTICATED: {
      const data = (action as ISetIsAuthenticated).payload;

      return { ...state, isAuthenticated: data, isAuthorized: data };
    }
    case AUTHENTICATION.SET_IS_ERROR: {
      const data = (action as ISetIsError).payload;

      return {
        ...state,
        isAuthenticated: false,
        isAuthorized: false,
        error: data,
      };
    }
    case AUTHENTICATION.SET_IS_BASE_URL_RETRIEVED: {
      const data = (action as IBaseURLRetrieved).payload;

      return { ...state, isBaseUrlRetrieved: data };
    }
    case AUTHENTICATION.ROTATE_TOKEN:
    case AUTHENTICATION.SIGN_IN:
    case AUTHENTICATION.SIGN_IN_PASSWORLESS_END:
    case AUTHENTICATION.SIGN_UP_NEW:
    case AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS:
    case AUTHENTICATION.GET_AUTH_DATA: {
      return {
        ...state,
        error: undefined,
        isLoading: true,
      };
    }
    case AUTHENTICATION.ROTATE_TOKEN_SUCCESS:
    case AUTHENTICATION.SIGN_IN_SUCCESS:
    case AUTHENTICATION.GET_AUTH_DATA_SUCCESS:
    case AUTHENTICATION.SIGN_UP_NEW_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        dateWhenExpire: StorageHelper.instance.GetExpireDate(),
        isLoggedOut: false,
        isLoading: false,
      };
    }
    case AUTHENTICATION.ROTATE_TOKEN_FAILURE:
    case AUTHENTICATION.SIGN_UP_NEW_FAILURE:
    case AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_FAILURE:
    case AUTHENTICATION.GET_AUTH_DATA_FAILURE:
    case AUTHENTICATION.SIGN_IN_FAILURE:
    case AUTHENTICATION.SIGN_IN_PASSWORLESS_END_FAILURE: {
      return {
        ...state,
        isAuthenticated: false,
        isAuthorized: false,
        isLoading: false,
      };
    }
    case AUTHENTICATION.CHANGE_PASSWORD: {
      return { ...state, changePassResult: { isLoading: true } };
    }
    case AUTHENTICATION.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePassResult: { isLoading: false, isSuccess: true },
      };
    }
    case AUTHENTICATION.CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        changePassResult: {
          isLoading: false,
          isSuccess: false,
          errorCode: (action as IChangePasswordFailure).payload,
        },
      };
    }
    case AUTHENTICATION.CHANGE_PASSWORD_CLEAR: {
      return {
        ...state,
        changePassResult: undefined,
      };
    }
    case AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL: {
      return {
        ...state,
        resetPassword: {
          isLoading: true,
          token: (action as IGetForgotPasswordEmail).payload,
        },
      };
    }
    case AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_SUCCESS: {
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          email: (action as IGetForgotPasswordEmailSuccess).payload,
        },
      };
    }
    case AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_FAILURE: {
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          forbidden: true,
        },
      };
    }
    case AUTHENTICATION.FORGOT_PASSWORD_END: {
      return {
        ...state,
        resetPassword: { ...state.resetPassword, isLoading: true },
      };
    }
    case AUTHENTICATION.FORGOT_PASSWORD_END_SUCCESS: {
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          finished: true,
          isLoading: false,
        },
      };
    }
    case AUTHENTICATION.FORGOT_PASSWORD_END_FAILURE: {
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          finished: false,
          isLoading: false,
        },
      };
    }
    case AUTHENTICATION.TOKEN_VALIDATE: {
      const data = (action as IValidateToken).payload;
      return {
        ...state,
        signUp: {
          ...state.signUp,
          isLoading: true,
          isRotated: false,
          token: data,
        },
      };
    }
    // case AUTHENTICATION.TOKEN_VALIDATE_SUCCESS: {
    //     const data = (action as IValidateTokenSuccess).payload;
    //     return {
    //         ...state,
    //         isPasswordLess: !validateEmail(data.email),
    //         signUp: { ...state.signUp, email: data.email, role: data.role, isRotated: true, isLoading: false },
    //     };
    // }

    case AUTHENTICATION.TOKEN_VALIDATE_FAILURE: {
      return {
        ...state,
        signUp: { ...state.signUp, isRotated: false, isLoading: false },
      };
    }
    case AUTHENTICATION.CHANGE_LANGUAGE: {
      return {
        ...state,
        signUp: {
          ...state.signUp,
          language: (action as IChangeRegisterLanguage).payload,
        },
      };
    }
    case AUTHENTICATION.SIGN_IN_CHECK: {
      return { ...state, signIn: { isLoading: true } };
    }
    case AUTHENTICATION.SIGN_IN_CHECK_RESULT: {
      const { result, isEmail, reason } = (action as ISignInCheckResult)
        .payload;

      if (!result && reason?.indexOf("block") !== -1)
        return {
          ...state,
          isAuthenticated: false,
          isAuthorized: false,
          isLoading: false,
          signIn: {
            ...state.signIn,
            isLoading: false,
            result: result,
            isBlocked: true,
          },
          isPasswordLess: !isEmail,
        };
      return {
        ...state,
        signIn: { isLoading: false, result: result },
        isPasswordLess: !isEmail,
      };
    }
    case AUTHENTICATION.SIGN_IN_SWITCH_TO_EMAIL: {
      return { ...state, isPasswordLess: false };
    }
    case AUTHENTICATION.SIGN_IN_SWITCH_TO_PHONE: {
      return { ...state, isPasswordLess: true };
    }
    case AUTHENTICATION.SIGN_IN_CHECK_CLEAR: {
      return { ...state, signIn: undefined };
    }
    case AUTHENTICATION.SIGN_IN_PASSWORLESS_END_SUCCESS: {
      const { phoneNumber, role, profileState } = (
        action as ISingInPasswordlessFinishSuccess
      ).payload;
      if (profileState && profileState === 2)
        return {
          ...state,
          isAuthenticated: true,
          dateWhenExpire: StorageHelper.instance.GetExpireDate(),
          isLoggedOut: false,
          isLoading: false,
        };
      return {
        ...state,
        isAuthenticated: true,
        dateWhenExpire: StorageHelper.instance.GetExpireDate(),
        isLoggedOut: false,
        isLoading: false,
        signUp: {
          ...state.signUp,
          email: phoneNumber,
          role: role as RoleType,
          isRotated: true,
          isLoading: false,
        },
      };
    }
    case USER_PROFILE.SUCCESS: {
      const { profileState, email, roleName } = (
        action as IUserProfileSuccessAction
      ).payload;
      if (profileState !== ProfileState.Completed) {
        return {
          ...state,
          signUp: {
            ...state.signUp,
            email: email,
            role: roleName as RoleType,
            isRotated: true,
            isLoading: false,
          },
        };
      }
      return state;
    }
    case USER_PROFILE.SET_USER_DATA_FROM_AUTH: {
      const { role, profileState, userId } = (action as ISetDataFromAuth)
        .payload;
      const profState = profileState
        ? profileState === 2
          ? ProfileState.Completed
          : profileState === 0
          ? ProfileState.NeedContactInfo
          : ProfileState.NeedOrganizationInfo
        : ProfileState.NeedContactInfo;
      if (profState !== ProfileState.Completed) {
        return {
          ...state,
          signUp: {
            ...state.signUp,
            role: role as RoleType,
            isRotated: true,
            isLoading: false,
          },
          isPasswordLess: userId.indexOf("sms") !== -1,
        };
      }
      return state;
    }
    case AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        dateWhenExpire: StorageHelper.instance.GetExpireDate(),
        isLoggedOut: false,
        isLoading: false,
        signUp: { language: navigatorToUs() },
      };
    }
    case AUTHENTICATION.ADD_PHONE: {
      const number = (action as IAddPhone).payload;
      return {
        ...state,
        addPhone: { isLoading: true, step: 1, username: number },
      };
    }
    case AUTHENTICATION.ADD_PHONE_SUCCESS: {
      return {
        ...state,
        addPhone: { ...state.addPhone, isLoading: false, isSuccess: true },
      };
    }
    case AUTHENTICATION.ADD_PHONE_FAILURE: {
      const code = (action as IAddPhoneFailure).payload;
      return {
        ...state,
        addPhone: {
          ...state.addPhone,
          isLoading: false,
          isSuccess: false,
          errorCode: code,
        },
      };
    }
    case AUTHENTICATION.ADD_PHONE_END: {
      return {
        ...state,
        addPhone: { ...state.addPhone, isLoading: true, step: 2 },
      };
    }
    case AUTHENTICATION.ADD_PHONE_END_SUCCESS: {
      return {
        ...state,
        addPhone: { ...state.addPhone, isLoading: false, isSuccess: true },
      };
    }
    case AUTHENTICATION.ADD_PHONE_END_FAILURE: {
      const code = (action as IAddPhoneFailure).payload;
      return {
        ...state,
        addPhone: {
          ...state.addPhone,
          isLoading: false,
          isSuccess: false,
          errorCode: code,
        },
      };
    }
    case AUTHENTICATION.ADD_PHONE_CLEAR: {
      return {
        ...state,
        addPhone: {
          ...state.addPhone,
          isLoading: undefined,
          isSuccess: undefined,
        },
      };
    }
    case AUTHENTICATION.ADD_EMAIL: {
      const number = (action as IAddEmail).payload;
      return {
        ...state,
        addEmail: { isLoading: true, step: 1, username: number },
      };
    }
    case AUTHENTICATION.ADD_EMAIL_SUCCESS: {
      return {
        ...state,
        addEmail: { ...state.addEmail, isLoading: false, isSuccess: true },
      };
    }
    case AUTHENTICATION.ADD_EMAIL_FAILURE: {
      const code = (action as IAddEmailEndFailure).payload;
      return {
        ...state,
        addEmail: {
          ...state.addEmail,
          isLoading: false,
          isSuccess: false,
          errorCode: code,
        },
      };
    }
    case AUTHENTICATION.ADD_EMAIL_END: {
      return {
        ...state,
        addEmail: { ...state.addEmail, isLoading: true, step: 2 },
      };
    }
    case AUTHENTICATION.ADD_EMAIL_END_SUCCESS: {
      return {
        ...state,
        addEmail: { ...state.addEmail, isLoading: false, isSuccess: true },
      };
    }

    case AUTHENTICATION.ADD_EMAIL_END_FAILURE: {
      const code = (action as IAddPhoneFailure).payload;
      return {
        ...state,
        addEmail: {
          ...state.addEmail,
          isLoading: false,
          isSuccess: false,
          errorCode: code,
        },
      };
    }
    case AUTHENTICATION.ADD_EMAIL_CLEAR: {
      return {
        ...state,
        addEmail: {
          ...state.addEmail,
          isLoading: undefined,
          isSuccess: undefined,
        },
      };
    }
    case AUTHENTICATION.EDIT_USERNAME: {
      const { type, username } = (action as IEditUsername).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: { isLoading: true, step: 1, username: username },
          }
        : {
            ...state,
            changeEmail: { isLoading: true, step: 1, username: username },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_SUCCESS: {
      const { type } = (action as IEditUsernameSuccess).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: {
              ...state.changePhone,
              isLoading: false,
              isSuccess: true,
            },
          }
        : {
            ...state,
            changeEmail: {
              ...state.changeEmail,
              isLoading: false,
              isSuccess: true,
            },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_FAILURE: {
      const { code, type } = (action as IEditUsernameFailure).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: {
              ...state.changePhone,
              isLoading: false,
              isSuccess: false,
              errorCode: code,
            },
          }
        : {
            ...state,
            changeEmail: {
              ...state.changeEmail,
              isLoading: false,
              isSuccess: false,
              errorCode: code,
            },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_END: {
      const { type } = (action as IEditUsernameEnd).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: { ...state.changePhone, isLoading: true, step: 2 },
          }
        : {
            ...state,
            changeEmail: { ...state.changeEmail, isLoading: true, step: 2 },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_END_SUCCESS: {
      const { type } = (action as IEditUsernameEndSuccess).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: {
              ...state.changePhone,
              isLoading: false,
              isSuccess: true,
            },
          }
        : {
            ...state,
            changeEmail: {
              ...state.changeEmail,
              isLoading: false,
              isSuccess: true,
            },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_END_FAILURE: {
      const { code, type } = (action as IEditUsernameEndFailure).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: {
              ...state.changePhone,
              isLoading: false,
              isSuccess: false,
              errorCode: code,
            },
          }
        : {
            ...state,
            changeEmail: {
              ...state.changeEmail,
              isLoading: false,
              isSuccess: false,
              errorCode: code,
            },
          };
    }
    case AUTHENTICATION.EDIT_USERNAME_CLEAR: {
      const type = (action as IEditUsernameClean).payload;
      return type === "sms"
        ? {
            ...state,
            changePhone: {
              ...state.changePhone,
              isLoading: undefined,
              isSuccess: undefined,
            },
          }
        : {
            ...state,
            changeEmail: {
              ...state.changeEmail,
              isLoading: undefined,
              isSuccess: undefined,
            },
          };
    }

    default:
      return state;
  }
};

export default reducer;
